import withLayout from '../../components/Layout/withLayout';

function PageNotFound() {
  return <div className="text-center">Page not Found.</div>;
}

export default withLayout(PageNotFound);
